import getColumnClipPath from './get-column-clip-path';

const clipPathResolvers = [getColumnClipPath];

const getHighlighterClipPath = (element, elementBounds) =>
  clipPathResolvers.map((resolveClipPath) => resolveClipPath(element, elementBounds)).find(Boolean);

export default getHighlighterClipPath;
